module.exports = __webpack_public_path__ + "static/media/stefan_neubauer.0df655ba.png";